'use strict';

const $ = window.jQuery;

export default class HeaderLanding {
    constructor() {
        $(window).on('scroll', function () {
            let scroll = $(window).scrollTop();

            if (scroll > 60) {
                $('#header-landing').addClass('is-sticky');
            } else {
                $('#header-landing').removeClass('is-sticky');
            }
        });
    }
}
